import ProgressBar from 'react-bootstrap/ProgressBar';

function MYProgressBar(props) {
  return <ProgressBar animated now={props.now} label={props.label} />;
}

export default MYProgressBar;